var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      class: [
        "lf-counter-wrapper",
        { "execute-action": _setup.props.info.action },
      ],
      on: { click: _setup.executeAction },
    },
    [
      _c(
        "div",
        { staticClass: "lf-counter" },
        [
          _c(
            "div",
            { staticClass: "text-container" },
            [
              _c("span", { staticClass: "text" }, [
                _vm._v(_vm._s(_setup.props.info.title)),
              ]),
              _setup.props.info.tooltipText
                ? _c(_setup.LexonTooltipComponent, {
                    attrs: {
                      icon: _setup.tooltipIcon,
                      message: _setup.props.info.tooltipText,
                      position: "top",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _setup.props.showSpinner
            ? _c(_setup.SpinnerLayerComponent, { staticClass: "spinner-layer" })
            : _c("span", { staticClass: "number" }, [
                _vm._v(_vm._s(_setup.formattedNumber)),
              ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }